import { Component, OnInit } from '@angular/core';
import {VersionModel} from '@app/shared/model/VersionModel';
import {DialogService} from 'primeng/api';
import {VersionService} from '@app/shared/services/version.service';

@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {

  infoApi: VersionModel;
  infoWeb: VersionModel;

  constructor(
    private versionSrv: VersionService
  ) {
  }

  async ngOnInit() {
    await this.getInfoVersaoApi();
    this.getInfoVersaoWeb();
  }

  private async getInfoVersaoApi() {
    await this.versionSrv.getInfoBackend().then(
      resultado => this.infoApi = resultado.data
    );
  }

  private getInfoVersaoWeb() {
      this.infoWeb = this.versionSrv.getInfoWeb();
  }

}
